import { render } from "./TarifNilaiTutamForm.vue?vue&type=template&id=dc627298"
import script from "./TarifNilaiTutamForm.vue?vue&type=script&lang=js"
export * from "./TarifNilaiTutamForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__